const partnerConfig = {};

export default partnerConfig;
